<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="标题"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          placeholder="请输入"
        />
      </el-form-item>
  
      <el-form-item
        label="图片"
        style="margin-right:15px"
        :required="true"
      >
        <ImgUpload
          :upload-config="{ lebal: '预览图片', prefix: 'img', form, suffix: '', modal: false }"
          :parent-data="{ isDetail: false }"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from "@/components/ImgUpload";

export default {
  name: 'HonorEdit',
  components: {
    ImgUpload
  },
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        branchCode: '',
        title: '',
        img: '',
        typeName: '',
        type: '',
        url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ],
       
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code, dicts) {
      this.dicts = dicts
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.$refs['form'].resetFields()
      request({ url: `/ntocc-basic-api/honor/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/honor', method: 'put', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherEditMethod')
          })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'edit')
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
